import {
  FETCH_LANGUAGES,
} from '../../mutation-types';

export default {
  [FETCH_LANGUAGES](state, languages) {
    state.all = languages;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/language/mutations.js